import { FC } from "react";

interface VectorSVGProps {
    width?: number;
    height?: number;
}

const VectorSVG: FC<VectorSVGProps> = ({ width = "18px", height = "18px" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="6" viewBox="0 0 7 6" fill="none">
            <path d="M3.5 6C2.72857 6 1.91429 5.65714 1.35714 5.1C0.8 4.54286 0.5 3.77143 0.5 3C0.5 2.22857 0.842857 1.45714 1.35714 0.857143C1.91429 0.3 2.68571 0 3.5 0C4.27143 0 5.04286 0.342857 5.6 0.857143C6.15714 1.41429 6.5 2.18571 6.5 3C6.5 3.77143 6.15714 4.54286 5.6 5.1C5.04286 5.65714 4.27143 6 3.5 6Z" fill="#9999A7" />
        </svg>
    );
};

export default VectorSVG;
